import React from 'react';
import NavBar from "../../components/navbar/nav-bar"
import { Col, Container, Row } from 'react-bootstrap';
import cover from '../../assets/shipment/utilita1.png'
import img1 from '../../assets/shipment/utilita2.png'
import img2 from '../../assets/shipment/utilita3.png'
import img3 from '../../assets/shipment/utilita4.png'


import signature from '../../assets/utils/signature.png'
import VideoHeroImage from "../../components/video_hero_image/video_hero_image";
import locationIcon from '../../assets/locationIcon.svg'

import './style.css'

function ShipmentMoto() {

    return <>
        <NavBar withBg={false} />
        <div style={{ marginBottom: '150px' }}></div>
        <Container > <img alt='utilita' src={cover} className='cover'></img></Container>
        <div style={{ marginBottom: '50px' }}></div>

        <Container className='alltext'>
            <Row className='takoFont sub-title'>CFR = Cost and Freight – Costo e nolo</Row>
            <Row>
                Nel termine "COSTO E NOLO" il venditore adempie l'obbligo di consegna, come nella precedente clausola FOB, nel momento in cui la merce ha oltrepassato la murata della nave nel porto d'imbarco convenuto. Il venditore deve sopportare tutte le spese necessarie per trasportare la merce fino al porto di destinazione convenuto, ma il rischio di perdita o di danni alla merce, come pure ogni spesa addizionale dovuta a fatti accaduti dopo che la merce sia stata consegnata a bordo della nave, si trasferisce dal venditore al compratore dal momento in cui la merce ha superato la murata della nave nel porto di imbarco. Nel termine CFR lo sdoganamento della merce all'esportazione è a carico del venditore. Questo termine può essere usato solo nel caso di trasporto marittimo o per vie navigabili interne. Quando la murata della nave non serve da linea discriminante (ad esempio trasporto containerizzato), l'uso del termine CPT (trasporto pagato fino a…) risulterebbe più appropriato.
            </Row>

            <Row className='takoFont sub-title'>BILL OF LADING</Row>
            <Row>
                La polizza di carico (in inglese Bill of lading, abbreviato B/L) è un documento "rappresentativo" di merce caricata su di una determinata nave (ship) in forza di un contratto di noleggio o di un contratto di trasporto. Il termine rappresentativo significa che il (legittimo) possessore del documento ha diritto di farsi consegnare la merce all'arrivo. È solitamente un documento "all'ordine" che si trasferisce mediante girata "endorsement" (proprio come un assegno).Questa caratteristica consente di trasferire una o più volte la proprietà della merce durante il viaggio e fino all'arrivo a destinazione.
            </Row>
            <Row className='takoFont sub-title'>La polizza di carico deve indicare</Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Il caricatore (forwarder)
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Il nome della nave
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Il porto d'imbarco (loading)
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Il poto di sbarco (unloading)
                </Col>
            </Row>


            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    La data prevista di partenza (sailing date)
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Il nome e la firma del vettore (carrier)
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    La descrizione della merce così come indicata dal caricatore (clausola "said to contain"), il suo valore e le condizioni di resa secondo l' incoterms (FOB, CIF, C&F, ecc,)
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    L'annotazione di merce "a bordo" (on board) datata e firmata dal capitano (master) della nave.
                </Col>
            </Row>
            <Row>
                Quest'ultima annotazione è particolarmente importante perché senza di essa il documento rimane una semplice ricevuta e non acquista la caratteristica di rappresentativo di merce liberamente trasferibile (negoziabile). Per le ragioni più sotto specificate la B/L deve inoltre indicare il numero degli originali emessi. La B/L deve inoltre essere "pulita" (clean), non contenere cioè indicazioni pregiudiziali per lo stato della merce ed il suo trasporto come ad esempio: contenitori o imballaggi usati o danneggiati, presenza di ruggine o inquinanti, sigilli rotti, caricamento sopra coperta (on deck), ecc.            </Row>

            <Row className='takoFont sub-title'>Infine la B/L liberamente negoziabile non deve</Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Essere stata emessa in forza di un contratto di spedizione (charter party) ma solo di un contratto di trasporto "port to port"
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Essere emessa da uno spedizioniere (forwarding agent) a meno che lo stesso non operi anche in qualità di vettore (as carrier).
                </Col>
            </Row>

            <Row>
                Allo scopo di evitare che un eventuale smarrimento del documento causi l'impossibilità di consegna della merce nel porto di arrivo la B/L viene emessa in più originali (solitamente tre) ad un unico effetto: una volta utilizzato un originale i restanti sono privi di efficacia. Chi vuole essere certo di vedersi consegnare la merce deve quindi avere in mano il "gioco completo" (full set) della B/L.
            </Row>

            <Row className='takoFont sub-title'>Assicurazione</Row>
            <Row>
                Qualora il Mandante intenda assicurare il rischio di danni o perdite alla merce, può dare mandato allo spedizioniere affinché provveda alla stipulazione di copertura assicurativa per conto di chi spetta. Le spese della predetta copertura verranno in tal caso specificate nella quotazione dello spedizioniere.
            </Row>
            <Row>
                In mancanza di istruzioni espresse da parte del Mandante l’eventuale copertura, sempre che richiesta, viene stipulata solo per i rischi ordinari, nelle forme usuali dell’assicurazione per conto di chi spetta o per conto altrui o in abbonamento. In nessun caso lo spedizioniere può essere considerato come assicuratore o coassicuratore. In alternativa il Mandante può provvedere ad assicurare direttamente la spedizione e/o il trasporto, restando inteso che, in tale eventualità, la relativa polizza dovrà contenere espressa rinuncia al diritto di rivalsa nei confronti dello spedizioniere da parte dell'assicuratore.
            </Row>
            <Row>
                Lo spedizioniere non ha l’obbligo di agire per conseguire l’indennizzo assicurativo, interrompere termini di prescrizione, curare lo svolgimento dell’attività peritale, salvo incarico in tal senso da parte del Mandante a fronte di corrispettivo da pattuirsi ad hoc.            </Row>


            <Row className='takoFont sub-title'>Cause di forza maggiore</Row>
            <Row>
                Lo spedizioniere non è in alcun caso responsabile per perdite, danni, ritardi, errate o mancate consegne causati da caso fortuito, da cause esimenti previste nella disciplina uniforme o di legge di cui all’articolo 11, e comunque da circostanze al di fuori del proprio controllo. Queste comprendono, a titolo esemplificativo ma non esaustivo: a) calamità naturali b) casi di forza maggiore quali guerre, incidenti/avarie a mezzi di trasporto o embarghi, sommosse o rivolte civili; c) difetti, caratteristiche intrinseche o vizi delle merci; d) atti, inadempimenti od omissioni del Mittente, del destinatario o di chiunque altro vanti un interesse nella spedizione, dell'Amministrazione dello Stato, doganale o postale o di altra Autorità competente e) scioperi, serrate o conflitti di lavoro.
            </Row>

            <Row className='takoFont sub-title'>Lo spedizioniere marittimo</Row>
            <Row>
                Vediamo in dettaglio che cosa fa uno spedizioniere marittimo:
            </Row>
            <Row>
                Mette a disposizione un magazzino dove raccogliere la merce nell'attesa di autorizzazione per la spedizione. S’incarica dell’espletamento di tutte le formalità doganali prescritte.
            </Row>
            <Row>Esegue le operazioni d’imbarco/sbarco e di controllo sottobordo nave, nonché di predisposizione della documentazione necessaria (polizze di carico, ecc). Negozia il nolo marittimo e consiglia la Compagnia di Navigazione più idonea al trasporto.

            </Row>

            <Row>Controlla le operazioni nel paese di destino, tramite un proprio agente che s’incaricherà di far proseguire la merce dal porto di sbarco fino alla destinazione finale.</Row>
            <Row>
                Mantiene i contatti con la Compagnia di Navigazione per essere costantemente a conoscenza della posizione della nave prevista per l’imbarco e potere quindi procedere all’avvio della merce al porto in tempo utile.
            </Row>
            <Row>
                Invia alla clientela un ‘’Avviso di spedizione ‘’ comunicando tutti i dettagli dell’imbarco il giorno stesso in cui questo avviene. Trasmette immediatamente (lo stesso giorno del ricevimento) tutta la documentazione rappresentativa della merce al cliente , incaricandosi dove richiesto , di curarne l’eventuale negoziazione in banca.
            </Row>
            <Row> Mantiene i contatti a destino per comunicare la data esatta in cui la merce è stata sbarcata e posta a disposizione del destinatario per il ritiro.
            </Row>
            <Row> Compila una “cartellina” con tutti i dati della spedizione. All’interno vi tiene tutti i documenti necessari.
            </Row>
            <Row> Registra costi e ricavi per avere sempre sotto controllo la “gestione” contabile della singola operazione Grazie alla fitta rete di propri corrispondenti in tutto il mondo, lo SPEDIZIONIERE è in grado di seguire la spedizione in tutta la sua tempistica dalla partenza fino a domicilio del ricevitore.
            </Row>
            <Row> Lo SPEDIZIONIERE tutela gli interessi del proprietario della merce nel “rapporto” con il proprietario della nave che è invece l’ARMATORE, rappresentato nel porto dall’AGENTE MARITTIMO.
            </Row>
            <Row> Tale RAPPORTO è regolato da un CONTRATTO i cui termini sono riportati nella POLIZZA DI CARICO.
            </Row>



            <Row className='takoFont sub-title'>Gestione di una spedizione</Row>
            <Row>
                Per coordinare al meglio una spedizione di merce, non basta avere gli strumenti operativi (un magazzino, una rete di camioncini per curare la distribuzione ed i ritiri di merce, accordi con gli auto–trasportatori per i “posizionamenti” dei container, contratti con le Compagnie di Navigazione per quanto riguarda i “noli marittimi”, rappresentanti nei Paesi esteri per seguire quanto succede al di là dal mare): bisogna essere in grado di preparare delle tariffe, da sottoporre alla clientela in base alle esigenze che vengono prospettate.
            </Row>


            <Row className='takoFont sub-title'>Assicurazione della merce</Row>
            <Row>
                Una prima netta distinzione va fatta: una cosa è l’assicurazione della merce ed altra è l’assicurazione del trasporto. L’assicurazione, dunque, può essere di diversi tipi, coprire rischi differenti, rimborsare somme più o meno alte. Nel momento in cui chi esporta decide di vendere merce con condizioni di pagamento dilazionate nel tempo, può assicurare il credito. Garantirsi, insomma, che il suo lavoro e la sua merce sarà pagata. In questo caso non si parla di danni, di mancanze, di perdita. Eppure siamo in presenza di un contratto di assicurazione con emissione di una relativa polizza assicurativa.
                Oppure, chi importa può assicurare la consegna della merce: se, dopo averla pagata, la merce non dovesse arrivargli, magari perdersi, forse rompersi o quant’altro, lui potrà, se non altro, recuperare la somma pagata.
                Quindi, non basta semplicisticamente parlare di “assicurazione” ma va specificato cosa, come, quanto!
            </Row>
            <Row className='takoFont sub-title'>Assicurazione del trasporto</Row>
            <Row>
                Un errore in cui incorrono in tanti è quello di pensare che affidando il trasporto ad un qualche vettore, questi, in caso di danno, debba rimborsarne il valore. Il rimborso del valore lo si ottiene solo se si è sottoscritta una POLIZZA ASSICURATIVA ALL RISKS (quella del punto precedente). Altrimenti in caso di danno, il diritto al rimborso non sarà MAI pari al valore della merce, ma soggetto a LIMITAZIONI legate, per lo più, al peso.
                E non solo: le limitazioni sono diverse a seconda della tipologia del trasporto.
                Una merce danneggiata durante un trasporto terrestre ha diritto al rimborso di una somma totalmente diversa da quella che spetta in caso di danno durante il trasporto marittimo, o quello aereo oppure ferroviario.

            </Row>


            <Row className='takoFont sub-title'>INTERNET</Row>
            <Row>
                Con l’avvento di INTERNET è cambiato anche il modo di gestire e controllare la spedizione.
                Oggi, infatti, è possibile effettuare tutta una serie di operazioni legate al trasporto senza bisogno di telefonare né di muoversi da casa o dall’ufficio, consultando il sito : www.marinetraffic.com avendo sempre ben presente la posizione della nave o del contenitore.
            </Row>

            <Row className='takoFont sub-title'>COSA E’ INCLUSO NELLA SPEDIZIONE</Row>
            <Row>
                E’ molto importante essere a conoscenza di che cosa è incluso nella spedizione e quali sono i costi che il cliente dovrà pagare a destino.
                Tutte le spedizioni trattate da NWSE, sono da considerarsi CFR, cioè “ COST & FREIGHT “. Questo termine comprende :
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    IL NOLO ( Freight ) il trasporto di una merce da un porto a un altro.
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    THC ( Terminal Handling Charges ) le spese di carico a bordo della nave del container
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Posizionamento per merce IMO
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Isps - Dem (Codice internazionale per la sicurezza delle navi e degli impianti portuali )
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Operazioni Doganale in Export
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Apertura carnet de Passage en Douane / ATA
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    BAF e CAF (Variazioni costo carburante e cambio al paese di destino )
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Alzata e Pulizia contenitore
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Surcharge Aden Gulf e Surcharge Suez Canal
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Emissione del Bill of Lading B/L ( Polizza di Carico )
                </Col>
            </Row>
            <Row className='takoFont sub-title'>COSA NON E’ INCLUSO NELLA SPEDIZIONE</Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    THC ( Terminal Handling Charges )a destino
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Scarico contenitore dalla nave
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Posizionamento in banchina
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Operazioni doganali al porto di destino
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Soste dopo la franchigia
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Gestione Pratica merce pericolosa
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Gestione Carnet de Passage en Douane / ATA
                </Col>
            </Row>
            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Magazzinaggio
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Surcharge Aden Gulf e Surcharge Suez Canal
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Eventuale posizionamento del contenitore in diverso magazzino per il carico / scarico
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Soste e deposito prima della partenza del contenitore
                </Col>
            </Row>

            <Row>
                <Col style={{ maxWidth: '30px' }}> <img alt='' src={locationIcon} className='locationIcon' /></Col>
                <Col md='11'>
                    Stivaggio
                </Col>
            </Row>

            <Row className='takoFont sub-title'>RESPONSABILITA’ RELATIVE AL TRASPORTO DI VEICOLI VIA NAVE O AEREO</Row>
            <Row>
                L’Organizzatores del viaggio, così come l’Agenzia di riferimento, per quanto concerne il trasporto dei veicoli di proprietà del partecipante, agisce quale mandataria e intermediaria con la compagnia che effettua il trasporto via nave o aereo, la responsabilità per danni diretti o indiretti derivanti da ritardo, perdita del carico, danneggiamento, salvataggio in mare, ed ogni altro fattore che possa determinare un danno al proprietario del veicolo, non potrà superare quanto previsto dalle condizioni di contratto di spedizione del vettore (Bill of Lading o Air Way Bill), dalle norme internazionali, dai codici di navigazione. L’assicurazione del carico è facoltativa e va richiesta in modo specifico dal cliente prima dell’emissione dei documenti di trasporto.
            </Row>
            <Container >
                <Row>
                    <Col md='4' style={{ padding: '0px' }} ><img alt='utilita' src={img1} className='cover'></img></Col>
                    <Col md='4' ><img alt='utilita' src={img2} className='cover'></img></Col>
                    <Col md='4' ><img alt='utilita' src={img3} className='cover'></img></Col>

                </Row>
            </Container>
            <Row>
                La responsabilità dell’Organizzatores. nei confronti del Cliente e dei beni di sua proprietà è regolata dalle Convenzioni Internazionali. La responsabilità dell’Organizzatores non può in alcun caso eccedere i limiti previsti dalle sopra citate convenzioni come di seguito specificati: danni relativi a perdita e/o furto relativi ai beni di proprietà del Cliente o alla persona del Cliente stesso, dipendenti dall’inadempimento delle prestazioni oggetto del Contratto di Viaggio da parte dell’Organizzatores o dei Terzi fornitori dei servizi durante l’espletamento del Viaggio. L’Organizzatores non sarà in alcun caso ritenuta responsabile dei danni di qualsiasi genere, allorché l’inadempimento o l’inesatta esecuzione del Contratto sia imputabile né a sua colpa, né a colpa di Terzi fornitori dei servizi, in quanto le mancanze constatate nell’esecuzione del Contratto siano derivate: a) da fatto del Cliente o da fatto di un Terzo a carattere imprevedibile o inevitabile; b) da circostanze estranee alla fornitura dei servizi previsti in Contratto; c) da caso fortuito, da forza maggiore ovvero da circostanze che L’Organizzatores non poteva, secondo la diligenza professionale, ragionevolmente prevedere o risolvere. Le seguenti circostanze, a titolo esemplificativo e non esaustivo, rientrano nei punti precedenti: a) eventi e/o catastrofi naturali; b) eventi geo-politici; c) cause di forza maggiore e/o caso fortuito; d) scioperi di qualsiasi natura; e) ritardi e/o modifiche operative di Compagnie di trasporto aeree e/o navali e/o di qualsiasi altra natura; f) per qualsiasi ragione tranne che per un fatto proprio del Cliente). L’Organizzatores non sarà inoltre in alcun caso ritenuta responsabile dei seguenti danni: a) conseguenti all’inosservanza da parte del Cliente di raccomandazioni e/o avvertenze impartite dall’accompagnatore e/o dalla guida turistica in loco; b) derivanti da fatto del Cliente e/o da iniziative autonome assunte dal Cliente stesso; c) derivanti da prestazioni di servizi forniti da Terzi e non facenti parte del Pacchetto Turistico.
            </Row>
            <Row style={{ color: '#EB5223' }}>IL PARTECIPANTE HA L’OBBLIGO DI PRENDERE ATTO ED ACCETTARE LE NORME RIPORTATE RELATIVE AL TRASPORTO DEL VEICOLO.</Row>
        </Container>
        <Row>
            <img alt='utilita' src={signature} className='cover'></img>
        </Row>

        <div style={{ marginBottom: '50px' }}></div>
        <VideoHeroImage />
    </>
}
export default ShipmentMoto